import Vue from "vue";
import App from "./App.vue";
import "es6-promise/auto";
import router from "./router";
import store from "./store";
import VeeValidate from "vee-validate";
import mgtVue from "./plugins/mgt-vue.js";
import axios from "./plugins/axios";
import notifications from "./plugins/notifications";

VeeValidate.Validator.extend("vAddress", {
  getMessage: (field) => `The ${field} field is not valid.`,
  validate(value, obj) {
    if (store.getters.isAddressValid) {
      return true;
    } else {
      return false;
    }
  },
});

Vue.config.productionTip = true;

Vue.use(mgtVue, { store });
Vue.use(VeeValidate);
Vue.use(notifications, { store });
Vue.use(axios, { store });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
